import React, { useContext } from 'react'
import YearlySalesInnerStyle from './css/YearlySalesInnerStyle'
import { Bar } from 'react-chartjs-2'
import { ContentInner } from '../../../../../layout/Content'
import { formatNumber } from '../../../../../utilities/utilities'
import PrinterSettingsStyle from '../../../../../../css/PrinterSettingsStyle'
import { yearlySalesContext } from './YearlySalesController'

function YearlySalesInner(props) {
  const yearlySalesController = useContext(yearlySalesContext)
  const { getClientDateTime, getClientTimezone } = yearlySalesController
  const yearlySales = yearlySalesController.yearlySales[0]

  const data = {
    labels: ((yearlySales) ? yearlySales.find(ys => ys.years).years : []),
    datasets: [
      {
        label: 'Net Sales',
        data: (
          (yearlySales)
          ? yearlySales.reduce((acc, cur) => {
              acc.push(cur.total_net_sales)
              return(acc)
            }, [])
          : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        ),
        backgroundColor: [ 'rgba(255, 99, 132, 0.2)' ],
        borderColor: [ 'rgba(255, 99, 132, 1)' ],
        borderWidth: 1,
      },
      {
        label: 'Gross Sales',
        data: (
          (yearlySales)
          ? yearlySales.reduce((acc, cur) => {
              acc.push(cur.total_gross_sales)
              return(acc)
            }, [])
          : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        ),
        backgroundColor: [ 'rgba(105, 199, 202, 0.2)' ],
        borderColor: [ 'rgba(105, 199, 202, 1)' ],
        borderWidth: 1,
      }
    ]
  }

  return (
    <ContentInner>
      <div className='report-wrapper'>
        <div id='yearly-sales-container' className='printable'>
          <h3>Yearly Sales (10 Years back)</h3>
          <div>As of {new Date(getClientDateTime()).toLocaleString("en-us")} { getClientTimezone() }</div>
          <br />
          <div className='data-and-chart-container'>
            <div className='left-wrapper'>
              <table className='yearly-sales-table striped'>
                <thead>
                  <tr>
                    <th>Year</th>
                    <th>Net Sales</th>
                    <th>Gross Sales</th>
                  </tr>
                </thead>
                {
                  (yearlySales)
                    ? yearlySales.filter(ys => ys.year).map((ys, index) => (
                        <tbody key={index}>
                          <tr>
                            <td>{ys.year}</td>
                            <td style={{textAlign: 'right'}}>P{formatNumber(ys.total_net_sales)}</td>
                            <td style={{textAlign: 'right'}}>P{formatNumber(ys.total_gross_sales)}</td>
                          </tr>
                        </tbody>
                      ))
                    : null
                  }
                <tbody>
                  <tr className='total'>
                    <td>Total</td>
                    <td style={{textAlign: 'right'}}>P{formatNumber((yearlySales) ? yearlySales.find(ys => ys.grand_total).grand_total.net_sales : 0 )}</td>
                    <td style={{textAlign: 'right'}}>P{formatNumber((yearlySales) ? yearlySales.find(ys => ys.grand_total).grand_total.gross_sales : 0 )}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className='right-wrapper'>
              <div className='yearly-sales-chart'>
                <Bar
                  data={data}
                  width={150}
                  height={70}
                  options={{
                    maintainAspectRatio: true,
                    plugins: {
                      title: {
                        display: true,
                        text: 'Yearly Sales'
                      }
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <YearlySalesInnerStyle />
      <PrinterSettingsStyle paperWidth='8.5inch'/>
    </ContentInner>
  )
}

export default React.memo(YearlySalesInner)